import * as angular from 'angular';

const fdVorbelegungHtml = require('../../views/fd_vorbelegung.html');

'use strict';

angular.module('formApp').directive('fdVorbelegung', function () {
  return {
    templateUrl: fdVorbelegungHtml,
    scope: false,
    link: function (scope) {
      scope.useExternalValue = !!scope.models.elementCopy.externalValue;
      scope.updateVorbelegung = function () {
        if (scope.useExternalValue) {
          scope.models.elementCopy.value = '';
        } else {
          delete scope.models.elementCopy.externalValue;
        }
      };
    },
    replace: true
  };
});
